import classNames from 'classnames';
import { useMemo } from 'react';
import { AssessmentState } from '../../types/assessment-state';

interface PlayerInitialsProps {
  state: AssessmentState;
  playerId: string;
  className?: string;
}

const BLANK_ID = '00000000-0000-0000-0000-000000000000';

export const PlayerInitials = ({
  state,
  playerId,
  className
}: PlayerInitialsProps) => {
  const playerInitialsClass = classNames('player-initials', className);
  const player = useMemo(
    () => state.players?.find((p) => p.code === playerId),
    [state]
  );
  const initials = playerId == BLANK_ID ? 'F' : (player?.initials ?? 'A');
  const backgroundColor =
    playerId == BLANK_ID ? '#4798cb' : (player?.color ?? '#13bf8b');
  const color =
    playerId == BLANK_ID ? 'white' : (player?.colorContrast ?? 'white');
  return (
    <div className={playerInitialsClass} style={{ backgroundColor, color }}>
      {initials}
    </div>
  );
};
